module.exports = __webpack_public_path__ + "media/images/beauty/card-desktop@3x-6631125d4edb4e8aed7672c9d8580266.jpg";